import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { trackEvent } from 'analytics'

type MonitoringLocation = {
  view: string
  hardwareType: string
  detailId: string
}

// Paths: /monitoring/map/..., /monitoring/sites/:focusId, /monitoring/ssids,
// /monitoring/infras/hardwares/:hardwareType/:uuid, /monitoring/topology/:focusId
const parseMonitoringLocation = (pathname: string): MonitoringLocation => {
  const [, view = 'map', ...rest] = pathname.split('/').filter(Boolean)

  if (view === 'infras') {
    const [, hardwareType = '', uuid = ''] = rest
    return { view, hardwareType, detailId: uuid }
  }
  if (view === 'sites') return { view, hardwareType: '', detailId: rest[0] ?? '' }

  return { view, hardwareType: '', detailId: '' }
}

const ViewTracker = () => {
  const { pathname } = useLocation()
  const { view, hardwareType, detailId } = parseMonitoringLocation(pathname)

  useEffect(() => {
    trackEvent('monitoring_view_opened', hardwareType ? { view, hardware_type: hardwareType } : { view })
  }, [view, hardwareType])

  useEffect(() => {
    if (!detailId) return
    if (view === 'sites') {
      trackEvent('monitoring_site_opened')
      return
    }
    trackEvent('monitoring_equipment_opened', { hardware_type: hardwareType })
  }, [detailId, view, hardwareType])

  return null
}

export default ViewTracker
